import { FamilyUnit, PossibleEmployerContributionDto } from '@zorro/clients';
import { ActionIcon } from '@zorro/design-system/v2/ActionIcon';
import { Tooltip } from '@zorro/design-system/v2/Tooltip';
import { InfoRoundIcon } from '@zorro/shared/assets';

import { AllowanceTooltipContent } from './AllowanceTooltipContent';

type AllowanceInfoTooltipProps = {
  rangeContributions: PossibleEmployerContributionDto[];
  labelText: string;
  familyUnit?: FamilyUnit;
};

export const AllowanceInfoTooltip = ({
  rangeContributions,
  labelText,
  familyUnit,
}: AllowanceInfoTooltipProps) => {
  const tooltipContent = (
    <AllowanceTooltipContent
      rangeContributions={rangeContributions}
      labelText={labelText}
      familyUnit={familyUnit}
    />
  );

  return (
    <Tooltip label={tooltipContent} position="top">
      <ActionIcon size="sm">
        <InfoRoundIcon />
      </ActionIcon>
    </Tooltip>
  );
};
